<!-- EditemployeeProfileModal.vue -->
<template>
  <b-modal v-model="showModal" title=" اضافة موظف" no-close-on-backdrop>
    <b-card title=" اضافة موظف">
      <b-form class="p-4" @submit.prevent="editemployee">
        <label>الاسم</label>
        <b-form-input
          v-model="employeeData.name"
          name="name"
          type="text"
          placeholder="الاسم "
        />

        <label>البريد الإلكترونى </label>

        <b-form-input
          v-model="employeeData.email"
          name="email"
          type="email"
          placeholder=" البريد الإلكترونى "
        />
        <label>الجنس  </label>

        <b-form-radio-group v-model="employeeData.gender" name="Gender">
    <b-form-radio value="Male">ذكر</b-form-radio>
    <b-form-radio value="Female">أنثى</b-form-radio>
  </b-form-radio-group>
        <b-row>
          <b-col md="6" cols="12">
            <label> الجوال </label>

            <b-form-input
              v-model="employeeData.phone"
              name="phone"
              type="phone"
              placeholder=" الجوال "
            />
          </b-col>
          <b-col md="6" cols="12">
            <label>المسمى الوظيفى</label>
            <b-form-input
              v-model="employeeData.position"
              name="position"
              type="text"
              placeholder=" المسمى الوظيفى "
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" cols="12">
            <label> سنين الخبرة </label>

            <b-form-input
              v-model="employeeData.experience"
              name="experience"
              type="number"
              placeholder=" سنين الخبرة "
            />
          </b-col>
          <b-col md="6" cols="12">
            <label>تاريخ الميلاد </label>

            <VueDatePicker
              v-model="employeeData.birthdate"
              :enable-time-picker="false"
              model-type="yyyy-MM-dd"
            ></VueDatePicker>
          </b-col>
        </b-row>

        <label>المؤهل </label>

        <b-form-input
          id="graduation_university"
          v-model="employeeData.graduation_university"
          trim
          placeholder=" المؤهل "
        />
        <label>الجنسية </label>

<v-select v-model="employeeData.nationality_id" :options="nationalities" label="name"     :reduce="(nationalities) => nationalities.id"
value="id"></v-select>
        <b-media no-body class="mb-1">
          <b-media-aside>
            <b-link>
              <b-img
                ref="previewEl"
                :src="employeeData.image.url"
                height="80"
                width="80"
              />
            </b-link>
            <!--/ image -->
          </b-media-aside>

          <b-media-body>
            <!-- upload button -->
            <b-button
              variant="primary"
              size="sm"
              class="mb-75 mr-75"
              @click="selectFile()"
            >
              اضافة صورة
            </b-button>
            <input
              ref="refInputEl"
              type="file"
              accept=".jpg, .png"
              style="display: none"
              @change="changeProfile"
            />
            <!--/ upload button -->
          </b-media-body>
        </b-media>
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-center"
        >
          <b-button
            class="form-btn"
            v-if="!loader"
            variant="primary"
            type="submit"
            block
          >
            <span> حفظ</span>
          </b-button>
          <b-button
            class="form-btn"
            v-if="loader"
            variant="primary"
            disabled
            block
          >
            <b-spinner small type="grow" />
            برجاء الانتظار...
          </b-button>
        </b-col>
      </b-form>
    </b-card>
  </b-modal>
</template>

    <script>
import axios from "axios";
import vSelect from 'vue-select';

export default {
    components: {vSelect},
  data() {
    return {
      showModal: false,
      loader: false,
      nationalities:[],
      employeeData: {
        image: {
          url: null,
        },
        birthdate: new Date(),
      },
      image: "",
    };
  },
  mounted(){
    this.fetchNationalities()
  },
  methods: {
    selectFile() {
      this.$refs.refInputEl.click();
    },
    changeProfile(e) {
      const input = e.target;
      if (input.files && input.files.length > 0) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.employeeData.image.url = event.target.result;
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    async fetchNationalities() {
  try {
    const response = await axios.get('nationalities');

    this.nationalities = response.data.data.nationalities; // Assign the API response to the data property
  } catch (error) {
    console.error('Error fetching cities details:', error);
  }
},

    editemployee() {
      const formData = new FormData();

      // eslint-disable-next-line no-restricted-syntax, guard-for-in
      for (const key in this.employeeData) {
        if (key !== "image") {
          formData.append(key, this.employeeData[key]);
        }
        if (this.image) {
          formData.append("image", this.image);
        }
      }
      this.loader = true;
      axios
        .post("companies/employees", formData)
        .then((res) => {
          if (res.status === 200 || res.status === 201) {
            this.showModal = false;
            window.location.reload();
            this.$toast.success("تم إضافة بنجاح ", {
              duration: 5000,
              position: "bottom-left",
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 500) {
            this.$toast.error(" هناك خظأ ما  ", {
              duration: 5000,
              position: "bottom-left",
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
